import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, NgZone, ChangeDetectionStrategy,ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import { MouseEvent, GoogleMapsAPIWrapper, AgmMap, LatLngBounds, LatLngBoundsLiteral, AgmMarker } from '@agm/core';
import { MarketBuildingService } from '../services/market-building.service';
import { TenantLeaseService } from '../services/tenant-lease.service';
import { LeaseFilter } from '../core/models/lease-filter';
import { Router } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { environment } from '../../environments/environment';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { saveAs } from "file-saver";
import { DatePipe } from '@angular/common';
import { Location } from '@angular/common';

am4core.useTheme(am4themes_animated);
import "core-js";
import { Session } from 'protractor';
import { BuildingScoresService } from '../services/building-scores.service';
import { Subscription } from 'rxjs';
import { FilterService } from '../services/filter.service';
import { FilterPreset } from '../core/models/filter-preset';
import { PortalType } from '../core/portal-types';
import { ListRatingFiltersComponent } from '../shared/list-rating-filters/list-rating-filters.component';
import { Paths } from '../constants';

declare var google: any;
declare var $: any;

const defaultMaxValue = 'No Max';
const defaultMinValue = 'No Min';

//declare var SelectGraphYear: Boolean;
//SelectGraphYear = false;
@Component({
	selector: 'app-tenant-lease-portal',
	templateUrl: './tenant-lease-portal.component.html',
	styleUrls: ['./tenant-lease-portal.component.css'],
// changeDetection :ChangeDetectionStrategy.OnPush
})

export class TenantLeasePortalComponent implements OnInit, AfterViewInit {

	public DEBUG_LIMIT_RESULTS:any = 99999;

	IconUrl = environment.BaseURI_Icon_MarketBuilding;
	private chart: am4charts.XYChart;
	colorImage: (string)[] = ['atlantis.png', 'blush.png', 'brightsun.png', 'burntsianna.png', 'choclaty.png',
		'curiousblue.png', 'grey.png', 'keppel.png', 'moodyblue.png', 'persianpink.png', 'strikemaster.png', 'treepoppy.png'];
	@ViewChild('fromDate') inputFromDate: ElementRef;
	@ViewChild('toDate') inputToDate: ElementRef;
	@ViewChild('AgmMap1') agmMap: AgmMap;
	@ViewChildren(AgmMarker) agmMarkers: QueryList<AgmMarker>;

	@ViewChild(ListRatingFiltersComponent) listRatingFiltersComponent!: ListRatingFiltersComponent;

	private selectedScoreWeightSubscription: Subscription;

	public portalType: PortalType = PortalType.Lease;
	public paths: any = Paths;

	public leaseFilter: LeaseFilter = {
		//Base Options
		buildingClasses: [],
		cities: [],
		dateEnd: null,
		dateStart: null,
		leaseTypes: [],
		ratingToRentRatioCurrent: {
			minimum: null,
			maximum: null
		},
		searchTerm: null,
		submarkets: [],
		districts: [],
		postalCodes: [],
		scoreWeightId: "",

		//Lease Options
		buildingRatingExecution: {
			minimum: null,
			maximum: null
		},
		dateRangeType: 0,
		dealTypes: [],
		effectiveRentalRate: {
			minimum: null,
			maximum: null
		},
		fullServiceStartingRate: {
			minimum: null,
			maximum: null
		},
		leaseTermMonths: {
			minimum: null,
			maximum: null
		},
		linkedInClassifications: [],
		linkedInGroups: [],
		monthsFreeRent: {
			minimum: null,
			maximum: null
		},
		propertyLeasedSquareFootage: {
			minimum: null,
			maximum: null
		},
		ratingToRentRatioExecution: {
			minimum: null,
			maximum: null
		},
		spaceConditions: [],
		squareFeet: {
			minimum: null,
			maximum: null
		},
		statuses: [],
		tenantImprovements: {
			minimum: null,
			maximum: null
		},

		//Rating Options
		total: {
			rating: [0, 105],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		constructionQuality: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		askingRate: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		commonAreaQuality: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		onSiteAmenities: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		sizeStories: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		ageBonus: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		locationProminence: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		relevanceToConsumer: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		locationConvenience: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		locationProximity: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		parkingVisitorExperience: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		parkingQuantity: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		parkingQuality: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
	};

	public cityOptions: string[];
	public postalOptions: string[];
	public statusOptions: string[];
	public submarketOptions: string[];
	public districtOptions: string[];
	public buildingClassOptions: string[];
	public dealTypeOptions: string[];
	public leaseTypeOptions: string[];
	private companyIndustryOptions: string[];
	public linkedInGroupOptions: string[];
	public linkedInClassificationOptions: string[];
	public spaceConditionOptions: string[];

	public userFilterPresets: FilterPreset[] = [];
	public userFilterPreset: FilterPreset = {
		id: "",
		name: "",
		userId: null,
		filter: null,
		createdUtc: null,
		updatedUtc: null
	}

	public myFormFromDate: FormGroup;
	public myFormTodate: FormGroup;
	public mapLoader = false;
	markers: marker[];
	tenantBuildinglist: any[];
	public tenantLeaseBuildingList: any = [];
	public tenantLeaseBuildingPopUpList: any = [];
	public tenantLeaseBuildingListCopy: any = [];

	rangeWalkScoreValues: number[] = [0, 100];
	rangeParkingRatioValues: number[] = [0, 100];
	rangeSFValues: number[] = [0, 1652149];
	rangeNumberOfFloorValue: number[] = [0, 100];
	rangeSFMaxValue: number = 352481;
	minValueSF: number = 10000;
	maxValueSF: number;
	zoom: number = 10;
	latitude: number = 33.438031;
	longitude: number = -111.955689;
	defaultCenter = { lat: 33.526567, lng: -112.064364, mapType: "roadmap" };
	currentCenter = Object.assign({}, this.defaultCenter);
	TenantLeaseobj: any = {};
	totalbuilding: number;
	est_StartingRate: number;
	Tenant_Imp: number;
	isPageFirstTime: boolean = true;
	isMarkerSingle: boolean = false;
	multipleName: string = 'a';
	rightSectionColor = { 'background': '#ffffff' };
	placeholder: string = '';
	public model: any = { date: { year: 2018, month: 10, day: 9 } };
	public model2: any = { date: { year: 2018, month: 10, day: 9 } };
	myDatePickerOptions: IMyDpOptions = {
		todayBtnTxt: 'Today',
		dateFormat: 'mm/dd/yyyy',
		ariaLabelInputField: '',
		firstDayOfWeek: 'mo',
		sunHighlight: true,
		inline: false,
	};
	data: any;
	subMarketdata: any;
	options: any;
	arraYears: Array<number>;
	arraSF: Array<number>;
	arrExpSubmarketSF: Array<number>;
	chartData: any;
	IsPdfGenerateForTenant: boolean = false;
	IsPropertyNameselected: boolean = false;
	deletedPropertyIdFromExistingList: string;
	// IsPropertyNameselected: boolean = false;
	selectedValue: boolean = false;
	selectedValueSubmarket: boolean = false;
	filterSelectedYear: string;
	clickFromYear: string;
	clickToYear: string;
	mapViewType: any;
	myMap:any;

	// customStyles: Array<any> = [ {"elementType": "geometry", "stylers": [{"color": "#ebe3cd"} ] }, {"elementType": "labels.text.fill", "stylers": [{"color": "#523735"} ] }, {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f1e6"} ] }, {"featureType": "administrative", "elementType": "geometry", "stylers": [{"visibility": "off"} ] }, {"featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{"color": "#c9b2a6"} ] }, {"featureType": "administrative.land_parcel", "elementType": "geometry.stroke", "stylers": [{"color": "#dcd2be"} ] }, {"featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{"color": "#ae9e90"} ] }, {"featureType": "landscape.natural", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "poi", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#93817c"} ] }, {"featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{"color": "#a5b076"} ] }, {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#447530"} ] }, {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#f5f1e6"} ] }, {"featureType": "road", "elementType": "labels.icon", "stylers": [{"visibility": "off"} ] }, {"featureType": "road.arterial", "elementType": "geometry", "stylers": [{"color": "#fdfcf8"} ] }, {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#f8c967"} ] }, {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"color": "#e9bc62"} ] }, {"featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [{"color": "#e98d58"} ] }, {"featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [{"color": "#db8555"} ] }, {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#806b63"} ] }, {"featureType": "transit", "stylers": [{"visibility": "off"} ] }, {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{"color": "#8f7d77"} ] }, {"featureType": "transit.line", "elementType": "labels.text.stroke", "stylers": [{"color": "#ebe3cd"} ] }, {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "water", "elementType": "geometry.fill", "stylers": [{"color": "#b9d3c2"} ] }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#92998d"} ] } ];
	customStyles: Array<any> = [{"elementType": "geometry", "stylers": [{"color": "#242f3e"} ] }, {"elementType": "labels.text.fill", "stylers": [{"color": "#746855"} ] }, {"elementType": "labels.text.stroke", "stylers": [{"color": "#242f3e"} ] }, {"featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [{"color": "#d59563"} ] }, {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#d59563"} ] }, {"featureType": "poi.attraction", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi.business", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#274e36"} ] }, {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#6b9a76"} ] }, {"featureType": "poi.place_of_worship", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi.school", "stylers": [{"visibility": "off"} ] }, {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#38414e"} ] }, {"featureType": "road", "elementType": "geometry.stroke", "stylers": [{"color": "#212a37"} ] }, {"featureType": "road", "elementType": "labels.text.fill", "stylers": [{"color": "#9ca5b3"} ] }, {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#746855"} ] }, {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"color": "#1f2835"} ] }, {"featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{"color": "#f3d19c"} ] }, {"featureType": "transit", "elementType": "geometry", "stylers": [{"color": "#2f3948"} ] }, {"featureType": "transit.station", "elementType": "labels.text.fill", "stylers": [{"color": "#d59563"} ] }, {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#3a65a6"} ] }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#515c6d"} ] }, {"featureType": "water", "elementType": "labels.text.stroke", "stylers": [{"color": "#17263c"} ] } ];

	preCout: number = 0;
	nextCount: number = 0;
	leaseIdToExportSingleRecord: number = 0;

	constructor(private datePipe: DatePipe, private zone: NgZone, private marketService: MarketBuildingService, private tenantLeaseService: TenantLeaseService, 
		private scoreService: BuildingScoresService, private filterService: FilterService, private route: Router, 
		private formBuilder: FormBuilder, private _cd :ChangeDetectorRef, private location:Location) {
	}

	ngOnInit() {
		this.getUserFilters();
		this.mapLoader = true;
		this.GetTenantLeaseStatus();
		this.GetTenantCity();
		this.GetTenantZip();
		this.TenantCompanyIndustryList();
		this.DefaultSelectedDate();
		this.TenantLeaseSubMarketList();
		this.TenantLeaseDistrictList();
		this.TenantLeaseBuildingClassList();
		this.TenantLeaseLeaseTypeList();
		this.TenantLeaseDealTypeList();
		this.TenantLeaseSpaceConditionList();
		this.TenantLeaseLinkedInGroupList();
		$('[data-toggle="tooltip"]').tooltip();
		$('.dataPickerInput').datepicker([]);
		$('.filterHead').click(function () {
			$(this).toggleClass("bodyShow");
			$(".filterBodySecond").slideToggle(300);
		});

		// this.agmMap.mapReady.subscribe(map => {
		// 	console.log('subscribe event called');
		// 	this.myMap = map;
		// 	this.geocode("Phoenix, USA").then(place => {
		// 		//this.currentCenter = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng(), mapType: "" };
		// 		this.currentCenter = { lat: 33.448376, lng: -112.074036, mapType: "" };
		// 		//console.log(this.currentCenter);
		// 	})
		// 	.catch(err => {
		// 	});
		// 	let query = this.route.parseUrl(this.route.url).queryParams;

		// 	if(query && Object.keys(query).length > 0) {
		// 		console.log(`doing filter based on ${JSON.stringify(query)}`);
		// 		this.onTenantLeaseFilterChange({},true,query);
		// 	}
		// 	else {
		// 		this.mapLoader = false;
		// 		//this.onTenantLeaseFilterChange(event,true);
		// 	}
		// });

		this.mapLoader = false;

	}

	buildingLinkOpenInNewTab(url: string): void {
		const fullUrl = window.location.origin + url;
    	window.open(fullUrl, '_blank');
	}

	ratingToRentRatioDisplay(rating: number) {
		if (rating == 0) {
			return "N/A";
		}
		return rating.toPrecision(3);
	}

	mapReady(map: any) {
		console.log("Map Ready");
		//this.myMap = map;
		let query = this.route.parseUrl(this.route.url).queryParams;

		this.selectedScoreWeightSubscription = this.scoreService.selectedWeight$.subscribe(value => {
			this.leaseFilter.scoreWeightId = value.id;

			if(query && Object.keys(query).length > 0) {
				console.log(`doing filter based on ${JSON.stringify(query)}`);
				this.onTenantLeaseFilterChange({},true,query);
			}
			else {
				this.mapLoader = false;
				this.onTenantLeaseFilterChange(event,true);
			}
		});
	}

	getUserFilters() {
		this.filterService.GetUserFilters(this.portalType).subscribe(
			(res: FilterPreset[]) => {
				this.userFilterPresets = res;
			},
			err => {
				console.log("Could not retrieve user filters: ", err);
			}
		);
	}

	userFilterChange(preset: FilterPreset) {
		try {
			this.leaseFilter = preset.filter;
		} catch (error) {
			console.log("Invalid filter.", error);
			alert("Invalid filter.");
		}
	}

	showFilterModal = false;

	openUserFilterModal() {
		this.showFilterModal = true;
	}

	closeUserFilterModal() {
		this.showFilterModal = false;
	}

	onDeleteUserFilter(filterId: string) {
		this.getUserFilters();
	}

	showFilterAddModal = false;

	openUserFilterAddModal() {
		this.showFilterAddModal = true;
	}

	closeUserFilterAddModal() {
		this.showFilterAddModal = false;
	}

	onAddUserFilter() {
		this.showFilterAddModal = false;
		this.getUserFilters();
	}

	DefaultSelectedDate() {
		this.leaseFilter.dateStart = new Date();
		this.leaseFilter.dateStart.setMonth(this.leaseFilter.dateStart.getMonth()-12);
		this.leaseFilter.dateEnd = new Date();
		this.myFormFromDate = this.formBuilder.group({
			myFromDate: [{ date: { year: this.leaseFilter.dateStart.getFullYear(), month: this.leaseFilter.dateStart.getMonth() + 1, day: this.leaseFilter.dateStart.getDate() } }, Validators.required]

		});
		this.myFormTodate = this.formBuilder.group({
			myToDate: [{ date: { year: this.leaseFilter.dateEnd.getFullYear(), month: this.leaseFilter.dateEnd.getMonth() + 1, day: this.leaseFilter.dateEnd.getDate() } }, Validators.required]
		});

		this.leaseFilter.dateStart= new Date(this.myFormFromDate.value.myFromDate.date.year, this.myFormFromDate.value.myFromDate.date.month - 1, this.myFormFromDate.value.myFromDate.date.day + 1);
		this.leaseFilter.dateEnd = new Date(this.myFormTodate.value.myToDate.date.year, this.myFormTodate.value.myToDate.date.month - 1, this.myFormTodate.value.myToDate.date.day + 1);
	}

	ngAfterViewInit() {
		this.agmMarkers.changes.subscribe((markers: QueryList<AgmMarker>) => {
			if (markers.length === this.tenantLeaseService.tenantLeaseBuildingList.length) {
			  this.onMarkersLoaded();
			}
		});
	}

	onMarkersLoaded() {
		console.log('All markers have finished loading.');
		
		const bounds = new google.maps.LatLngBounds();
		this.tenantLeaseService.tenantLeaseBuildingList.forEach(point => {
			bounds.extend(new google.maps.LatLng(point.latitude, point.longitude));
		});

		// Set the bounds on the map
		this.myMap.fitBounds(bounds);
	}

	ngOnDestroy() {
		this.zone.runOutsideAngular(() => {
			if (this.chart) {
				this.chart.dispose();
			}
		});

		if (this.selectedScoreWeightSubscription) {
			this.selectedScoreWeightSubscription.unsubscribe();
		  }
	}

	public getRandomValues(rowCount: number, maxValue: number): Array<number> {
		return new Array(rowCount).fill(0).map(() => Math.round(Math.random() * maxValue));
	}
	geocode(address: string): Promise<any> {
		const geocoder = new google.maps.Geocoder();
		return new Promise((resolve, reject) => {
			geocoder.geocode(
				{
					address: address
				},
				(results, status) => {
					if (status === google.maps.GeocoderStatus.OK) {
						console.log(results);
						resolve(results[0]);
					} else {
						reject(new Error(status));
					}
				}
			);
		});
	}
	
	getCurrentPreviousQuarter(value) {
		var today = new Date(),
			quarter = Math.floor((today.getMonth() / 3)),
			startDate,
			endDate;

		switch (value) {
			case "previous":
				startDate = new Date(today.getFullYear(), quarter * 3 - 3, 1);
				endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
				break;
			default:
				startDate = new Date(today.getFullYear(), quarter * 3, 1);
				endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
				break;
		}

		return {
			StartDate: startDate,
			EndDate: endDate
		};
	}

	onRadioDateChanged(event, dateType) {
		console.log("onRadioDateChanged");
		this.onTenantLeaseFilterChange({});
	}

	ClearAll() {
		this.clearFilters();
		this.getUserFilters();
		this.DefaultSelectedDate();
		this.onTenantLeaseFilterChange(event,true);
	}

	clearFilters() {
		//Base Options
		this.leaseFilter.buildingClasses = [];
		this.leaseFilter.cities = [];
		this.leaseFilter.leaseTypes = [];
		this.leaseFilter.ratingToRentRatioCurrent.minimum = null;
		this.leaseFilter.ratingToRentRatioCurrent.maximum = null;
		this.leaseFilter.searchTerm = null;
		this.leaseFilter.submarkets = [];
		this.leaseFilter.districts = [];
		this.leaseFilter.postalCodes = [];

		//Lease Options
		this.leaseFilter.buildingRatingExecution.minimum = null;
		this.leaseFilter.buildingRatingExecution.maximum = null;
		this.leaseFilter.dateRangeType = 0;
		this.leaseFilter.dealTypes = [];
		this.leaseFilter.effectiveRentalRate.minimum = null;
		this.leaseFilter.effectiveRentalRate.maximum = null;
		this.leaseFilter.fullServiceStartingRate.minimum = null;
		this.leaseFilter.fullServiceStartingRate.maximum = null;
		this.leaseFilter.leaseTermMonths.minimum = null;
		this.leaseFilter.leaseTermMonths.maximum = null;
		this.leaseFilter.linkedInClassifications = [];
		this.leaseFilter.linkedInGroups = [];
		this.leaseFilter.monthsFreeRent.minimum = null;
		this.leaseFilter.monthsFreeRent.maximum = null;
		this.leaseFilter.propertyLeasedSquareFootage.minimum = null;
		this.leaseFilter.propertyLeasedSquareFootage.maximum = null;
		this.leaseFilter.ratingToRentRatioExecution.minimum = null;
		this.leaseFilter.ratingToRentRatioExecution.maximum = null;
		this.leaseFilter.spaceConditions = [];
		this.leaseFilter.squareFeet.minimum = null;
		this.leaseFilter.squareFeet.maximum = null;
		this.leaseFilter.statuses = [];
		this.leaseFilter.tenantImprovements.minimum = null;
		this.leaseFilter.tenantImprovements.maximum = null;

		this.listRatingFiltersComponent.clearRatingFilters();
	}

	onDateChanged(event, dateType) {
		console.log("onDateChanged");
		if (dateType == 'from') {
			if (event.date.year == 0 && event.date.month == 0 && event.date.day == 0) {
				this.leaseFilter.dateStart = null;
			}
			else {
				this.leaseFilter.dateStart = new Date(event.date.year, event.date.month - 1, event.date.day + 1);
			}
		}
		else
		{
			if (event.date.year == 0 && event.date.month == 0 && event.date.day == 0) {
					this.leaseFilter.dateEnd = null;
			}
			else {
					this.leaseFilter.dateEnd = new Date(event.date.year, event.date.month - 1, event.date.day+1);
			}
		}

		this.onTenantLeaseFilterChange({});
	}

	TenantLeaseSubMarketList() {
		this.tenantLeaseService.TenantLeaseSubMarketList().subscribe(
			(res: string[]) => {
				this.submarketOptions = res;
			},
			err => {

			}
		);
	}

	TenantLeaseDistrictList() {
		this.tenantLeaseService.TenantLeaseDistrictList().subscribe(
			(res: string[]) => {
				this.districtOptions = res;
			},
			err => {

			}
		);
	}

	TenantLeaseBuildingClassList() {
		this.tenantLeaseService.TenantLeaseBuildingClassList().subscribe(
			(res: string[]) => {
				this.buildingClassOptions = res;
			},
			err => {

			}
		);
	}

	TenantLeaseLeaseTypeList() {
		this.tenantLeaseService.TenantLeaseLeaseTypeList().subscribe(
			(res: string[]) => {
				this.leaseTypeOptions = res;
			},
			err => {

			}
		);
	}

	TenantLeaseDealTypeList() {
		this.tenantLeaseService.TenantLeaseDealTypeList().subscribe(
			(res: string[]) => {
				this.dealTypeOptions = res;
			},
			err => {

			}
		);
	}

	TenantLeaseSpaceConditionList() {
		this.tenantLeaseService.TenantLeaseSpaceConditionList().subscribe(
			(res: string[]) => {
				this.spaceConditionOptions = res;
			},
			err => {

			}
		);
	}

	TenantLeaseLinkedInGroupList() {
		this.tenantLeaseService.TenantLeaseLinkedInGroupList().subscribe(
			(res: string[]) => {
				this.linkedInGroupOptions = res;
			},
			err => {
			}
		);
	}

	TenantLeaseLinkedInClassificationList(linkedInGroupName) {
		this.tenantLeaseService.TenantLeaseLinkedInClassificationList().subscribe(
			(res: string[]) => {
				this.linkedInClassificationOptions = res;
			},
			err => {
			}
		);
	}

	TenantCompanyIndustryList() {
		this.tenantLeaseService.TenantCompanyIndustryList().subscribe(
			(res: string[]) => {
				this.companyIndustryOptions = res;
			},
			err => {
			}
		);
	}

	BuildingSquareFootageMinMaxValue() {
		this.tenantLeaseService.TenantLeaseSquareFootageMinMaxValue().subscribe(
			(res: any) => {
				this.rangeSFValues = [];
				this.minValueSF = res["0"].minSFValue;
				this.maxValueSF = res["0"].maxSFValue;
				this.rangeSFValues = [0, this.maxValueSF];
				this.rangeSFMaxValue = this.maxValueSF;
			},
			err => {

			}
		);
	}

	onTenantLeaseFilterChange({ },actually=false, queryParams=null) {

		if (!actually) {
			return;
		}
		this.mapLoader = true;

		if (queryParams) {
			this.tenantLeaseService.TenantLeaseDetailByPropertyIds([queryParams.propertyId], this.leaseFilter.scoreWeightId).subscribe((res: any) => {

				res = res.filter(e=>e.propertyId == queryParams.propertyId);
				// res = res.filter(e=>e.s == queryParams.propertyId);

				this.tenantLeaseBuildingList = res;

				//Updating service list for pdf export and added logic to remove extra data from list
				this.tenantLeaseService.tenantLeaseBuildingList = res.filter(obj => obj.leaseId != -1);
				this.tenantLeaseBuildingListCopy = this.tenantLeaseService.tenantLeaseBuildingList.slice(0, 50);

				this.pushInMarker();
				this._cd.detectChanges();

				// this.markers = res;

				if(this.myMap) {
					console.log('1 Resizing map bounds ...');
					console.log(this.tenantLeaseBuildingList);
					console.log(this.tenantLeaseService.tenantLeaseBuildingList);
					// setTimeout(()=>{
					// 	const bounds: LatLngBounds = new google.maps.LatLngBounds();
					// 	for (const mm of this.tenantLeaseService.tenantLeaseBuildingList) {
					// 		bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
					// 	}
					// 	this.myMap.fitBounds(bounds)}
					// ,0);
				}
			},
			err => {
				this.mapLoader = false;
			});
			return;
		}
		else {
			this.location.go('/tenantLeasePortal');
		}

		//Stored data into sevice property to use further implemenation
		//this.tenantLeaseService.rangeSFValuesMin = this.rangeSFValues[0];
		//this.tenantLeaseService.rangeSFValuesMax = this.rangeSFValues[1];
		this.tenantLeaseService.propertyName = "";
		this.tenantLeaseService.companyName = "";
		this.deletedPropertyIdFromExistingList = "";
		this.tenantLeaseService.leaseIdSingleSelection = "";
		let newDate = '';

		this.tenantLeaseService.TenantLeaseDetailbyFilter
		(
			this.leaseFilter
		).subscribe((res: any) => {

				this.listRatingFiltersComponent.filterBuildings(res).subscribe(filteredBuildings => {
					this.tenantLeaseBuildingList = filteredBuildings;
					this.tenantLeaseService.tenantLeaseBuildingList = filteredBuildings;
					this.tenantLeaseBuildingListCopy = filteredBuildings;

					this.pushInMarker();
					this._cd.detectChanges();
				});

				if (this.myMap) {
					// setTimeout(()=> {
					// 	const bounds: LatLngBounds = new google.maps.LatLngBounds();
					// 	for (const mm of this.tenantLeaseService.tenantLeaseBuildingList) {
					// 		bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
					// 	}
					// 	this.myMap.fitBounds(bounds)
				}
			},
			err => {
				this.mapLoader = false;
			}
		);
	}

	onExpirationBySubmarketChange({ }) {
		this.mapLoader = true;
		this.deletedPropertyIdFromExistingList = "";
		this.tenantLeaseService.leaseIdSingleSelection = "";

		this.tenantLeaseService.TenantLeaseDetailbyFilter( this.leaseFilter ).subscribe(
			(res: any) => {
				// console.log(res,'data');
				this.tenantLeaseBuildingList = res;
				//Updating service list for pdf export and added logic to remove extra data from list
				this.tenantLeaseService.tenantLeaseBuildingList = res.filter(obj => obj.leaseId != -1);
				this.tenantLeaseBuildingListCopy = this.tenantLeaseService.tenantLeaseBuildingList.slice(0, 50);
				this.pushInMarker();

				if(this.myMap) {
					console.log('3 Resizing map bounds ...');
					console.log(this.tenantLeaseBuildingList);
					console.log(this.tenantLeaseService.tenantLeaseBuildingList);
					// setTimeout(()=>{
					// 	const bounds: LatLngBounds = new google.maps.LatLngBounds();
					// 	for (const mm of this.tenantLeaseService.tenantLeaseBuildingList) {
					// 		bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
					// 	}
					// 	this.myMap.fitBounds(bounds)}
					// ,0);
				}
				// console.log(res);
			//  this._cd.markForCheck();
			},
			err => {

			}

		);
	}
	mapClicked($event: MouseEvent) {
		var ghjghjk = this.agmMap.mapTypeId.valueOf();
		draggable: false
	}
	markerDragEnd(m: location, $event: MouseEvent) {
		//console.log('dragEnd', m, $event);
	}

	PreEvent(propertyId)
	{
		if (this.preCout == 0) {
			if (this.nextCount > 0) {
				this.preCout = this.nextCount;
				if (this.preCout != 0) {
					this.PreCoutEventDetails();
					$("#btnPrevious").attr("disabled", false);
					this.nextCount = 0;
				}
			}
			else { $("#btnPrevious").attr("disabled", true);}
		}
		else {
			$("#btnPrevious").attr("disabled", false);
			this.PreCoutEventDetails();
		}

	}

	PreCoutEventDetails() {
		$("#btnNext").attr("disabled", false);
		this.preCout--;
		this.leaseIdToExportSingleRecord = this.tenantLeaseBuildingPopUpList[this.preCout].leaseId;
		$(".preNextDynamicData_propertyNameData").text(this.tenantLeaseBuildingPopUpList[this.preCout].propertyName);
		$(".preNextDynamicData_companyNameData").text(this.tenantLeaseBuildingPopUpList[this.preCout].companyName);
		$(".preNextDynamicData_propertyAddressData").text(this.tenantLeaseBuildingPopUpList[this.preCout].propertyAddress);
		$(".preNextDynamicData_squareFootageData").text((this.tenantLeaseBuildingPopUpList[this.preCout].squareFootage).toLocaleString("en") + " SF");
		$(".preNextDynamicData_submarketData").text(this.tenantLeaseBuildingPopUpList[this.preCout].submarket);
		$(".preNextDynamicData_leaseExecutionData").text(this.datePipe.transform(this.tenantLeaseBuildingPopUpList[this.preCout].leaseExecution, 'MM/dd/yyyy'));
		$(".preNextDynamicData_dealTypeData").text(this.tenantLeaseBuildingPopUpList[this.preCout].dealType);
		$(".preNextDynamicData_buildingClassData").text(this.tenantLeaseBuildingPopUpList[this.preCout].buildingClass);
		$(".preNextDynamicData_estimatedStartingFSRateData").text("$"+parseFloat(this.tenantLeaseBuildingPopUpList[this.preCout].estimatedStartingFSRate).toFixed(2));
		$(".preNextDynamicData_tenantImprovementsData").text("$"+parseFloat(this.tenantLeaseBuildingPopUpList[this.preCout].tenantImprovements).toFixed(2));
		$(".preNextDynamicData_leaseTermMonthsData").text(this.tenantLeaseBuildingPopUpList[this.preCout].leaseTermMonths);
		$(".preNextDynamicData_leaseCommencementDateData").text(this.datePipe.transform(this.tenantLeaseBuildingPopUpList[this.preCout].leaseCommencementDate, 'MM/dd/yyyy'));
		$(".preNextDynamicData_leaseExpirationDateData").text(this.datePipe.transform(this.tenantLeaseBuildingPopUpList[this.preCout].leaseExpirationDate, 'MM/dd/yyyy'));
		$(".preNextDynamicData_escalationsData").text(this.tenantLeaseBuildingPopUpList[this.preCout].escalations);
	}


	NextEvent(propertyId) {
		if (this.nextCount == this.tenantLeaseBuildingPopUpList.length-1) {
			if (this.preCout > 0) {
				this.nextCount == this.preCout;
				this.NextCountEventDetails();
				$("#btnNext").attr("disabled", false);
				this.preCout = 0;
			}
			else {

				$("#btnNext").attr("disabled", true);
			}
		}
		else {
			$("#btnNext").attr("disabled", false);
			this.NextCountEventDetails();
		}
	}
	NextCountEventDetails() {
		$("#btnPrevious").attr("disabled", false);
		this.nextCount++;
		this.leaseIdToExportSingleRecord = this.tenantLeaseBuildingPopUpList[this.nextCount].leaseId;
		$(".preNextDynamicData_propertyNameData").text(this.tenantLeaseBuildingPopUpList[this.nextCount].propertyName);
		$(".preNextDynamicData_companyNameData").text(this.tenantLeaseBuildingPopUpList[this.nextCount].companyName);
		$(".preNextDynamicData_propertyAddressData").text(this.tenantLeaseBuildingPopUpList[this.nextCount].propertyAddress);
		$(".preNextDynamicData_squareFootageData").text((this.tenantLeaseBuildingPopUpList[this.nextCount].squareFootage).toLocaleString("en") + " SF");
		$(".preNextDynamicData_submarketData").text(this.tenantLeaseBuildingPopUpList[this.nextCount].submarket);
		$(".preNextDynamicData_leaseExecutionData").text(this.datePipe.transform(this.tenantLeaseBuildingPopUpList[this.nextCount].leaseExecution, 'MM/dd/yyyy'));
		$(".preNextDynamicData_dealTypeData").text(this.tenantLeaseBuildingPopUpList[this.nextCount].dealType);
		$(".preNextDynamicData_buildingClassData").text(this.tenantLeaseBuildingPopUpList[this.nextCount].buildingClass);
		$(".preNextDynamicData_estimatedStartingFSRateData").text("$"+parseFloat(this.tenantLeaseBuildingPopUpList[this.nextCount].estimatedStartingFSRate).toFixed(2));
		$(".preNextDynamicData_tenantImprovementsData").text("$"+parseFloat(this.tenantLeaseBuildingPopUpList[this.nextCount].tenantImprovements).toFixed(2));
		$(".preNextDynamicData_leaseTermMonthsData").text(this.tenantLeaseBuildingPopUpList[this.nextCount].leaseTermMonths);
		$(".preNextDynamicData_leaseCommencementDateData").text(this.datePipe.transform(this.tenantLeaseBuildingPopUpList[this.nextCount].leaseCommencementDate, 'MM/dd/yyyy'));
		$(".preNextDynamicData_leaseExpirationDateData").text(this.datePipe.transform(this.tenantLeaseBuildingPopUpList[this.nextCount].leaseExpirationDate, 'MM/dd/yyyy'));
		$(".preNextDynamicData_escalationsData").text(this.tenantLeaseBuildingPopUpList[this.nextCount].escalations);

	}

	clickedMarker(abc, index: number, add, infoWindow) {
		infoWindow._closeInfoWindow();
		this.preCout = 0;
		this.nextCount = 0;
		$("#btnPrevious").attr("disabled", true);
		$("#btnNext").attr("disabled", true);
		this.tenantLeaseBuildingPopUpList = this.tenantLeaseBuildingList.filter(obj => obj.propertyAddress == add);
		//console.log(this.tenantLeaseBuildingList.filter(obj => obj.propertyAddress == add));
		//console.log(`clicked the marker: ${index}` + index + abc);
	}
	mouseOver(infoWindow, $event: MouseEvent, name, iconURL) {
		// console.log(iconURL);
		if(document.getElementById("mapContentBox") == null){
		// infoWindow._openInfoWindow();
			infoWindow.open();
		}
	}
	mouseOut(infoWindow, $event: MouseEvent, name) {
		// console.log('closing info window');
		// infoWindow._closeInfoWindow();
		infoWindow.close();
	}
	zoomChange() {
		console.log("zoom: ", this.myMap.getZoom());
	}
	//Calculate value for building 05102019
	pushInMarker() {
		//pointer coloring base on building 11102019
		let listchange: any[];
		if (this.isMarkerSingle) {
			listchange = this.tenantLeaseBuildingListCopy;
		}
		else {
			listchange = this.tenantLeaseBuildingList;
		}
		this.tenantLeaseBuildingList = listchange;
		this.tenantLeaseBuildingList.forEach((TenantLeaseobj, index) => {
			TenantLeaseobj["iconUrl"] = this.IconUrl + TenantLeaseobj.submarketCode;

		});
		//this.caluculateTotleSQFT()
		var that = this;
		let totalSF = 0;
		let est_SRate = 0;
		let tenant_Imp = 0;
		listchange.filter(function (location) {
			totalSF = Number(totalSF) + Number(location["squareFootage"]);
			est_SRate = Number(est_SRate) + Number(location["estimatedStartingFSRate"]);
			tenant_Imp = Number(tenant_Imp) + Number(location["tenantImprovements"]);
		});
		// this.markers = locationArray;
		this.TenantLeaseobj.totalSF = totalSF;
		this.TenantLeaseobj.tenant_Imp = tenant_Imp;
		this.TenantLeaseobj.est_SRate = (Number(est_SRate));

		this.Tenant_Imp = (Number(that.TenantLeaseobj.tenant_Imp) / (listchange.length ));
		this.est_StartingRate = (Number(that.TenantLeaseobj.est_SRate) / Number(listchange.length));
		this.totalbuilding = listchange.length;
		
		this.mapLoader = false;
	};
	pushInMarkerSingleDetail(obj): void {
		if (this.IsPropertyNameselected) {
			this.IsPropertyNameselected = false;
			 }
		else {
			this.IsPropertyNameselected = false;
				let listchange: any[];
				if (this.isPageFirstTime == true) {
					this.isMarkerSingle = true;
					this.TenantLeaseobj = Object.create(obj);
					this.totalbuilding = 1;
					this.markers = [obj.location];
					let Rsf = 0;
					let Sf = 0;
					this.tenantLeaseBuildingListCopy = [obj];
					this.pushInMarker();
					var that = this;
					let totalSF = 0;
					let est_SRate = 0;
					let tenant_Imp = 0;
					this.tenantLeaseBuildingListCopy.filter(function (location) {
						totalSF = Number(totalSF) + Number(location["squareFootage"]);
						est_SRate = Number(est_SRate) + Number(location["estimatedStartingFSRate"]);
						tenant_Imp = Number(tenant_Imp) + Number(location["tenantImprovements"]);
					});
					this.TenantLeaseobj.totalSF = totalSF;
					this.TenantLeaseobj.tenant_Imp = tenant_Imp;
					this.TenantLeaseobj.est_SRate = (Number(est_SRate));
					this.Tenant_Imp = (Number(that.TenantLeaseobj.tenant_Imp) / (this.tenantLeaseBuildingListCopy.length));
					this.est_StartingRate = (Number(that.TenantLeaseobj.est_SRate) / Number(this.tenantLeaseBuildingListCopy.length));
					this.totalbuilding = this.tenantLeaseBuildingListCopy.length;
					this.rightSectionColor = { 'background': '#b9c7d0' };
					this.isPageFirstTime = false;
					this.isMarkerSingle = false;

					//Updating service list for pdf export
					this.tenantLeaseService.leaseIdSingleSelection = obj["leaseId"];
					this.tenantLeaseService.tenantLeaseBuildingList = this.tenantLeaseBuildingListCopy;
				}
				else {
					this.tenantLeaseService.leaseIdSingleSelection = "";
					this.onTenantLeaseFilterChange(event,true);
					this.rightSectionColor = { 'background': '#ffffff' };
					this.isPageFirstTime = true;
				}
		}


	}
	ShowAllBuildingRecord() {
		//this.tenantLeaseBuildingListCopy = this.tenantLeaseBuildingList;
		this.tenantLeaseBuildingListCopy = this.tenantLeaseBuildingList;
		
		this.onTenantLeaseFilterChange(event,true);
	}
		selectData(filterYear,flag) {
				if (flag) {
					 //this.fromDate = new Date(filterYear, 1, 1);
					 // this.endDate = new Date(filterYear, 12, 30);
						this.clickFromYear = filterYear + '-' + '01' + '-' + '01';
						this.clickToYear = filterYear + '-' + '12' + '-'+ '31';
						this.leaseFilter.dateStart = new Date(this.clickFromYear);
						this.leaseFilter.dateEnd = new Date(this.clickToYear);
						this.leaseFilter.dateRangeType = 1;
				}
				else {
						if (this.myFormFromDate.value.myFromDate != null && this.myFormTodate.value.myToDate != null) {
								this.leaseFilter.dateStart = new Date(this.myFormFromDate.value.myFromDate.date.year, this.myFormFromDate.value.myFromDate.date.month - 1, this.myFormFromDate.value.myFromDate.date.day + 1);
								this.leaseFilter.dateEnd = new Date(this.myFormTodate.value.myToDate.date.year, this.myFormTodate.value.myToDate.date.month - 1, this.myFormTodate.value.myToDate.date.day + 1);
								this.leaseFilter.dateRangeType = 0;
								//console.log(this.fromDate);
								//console.log(this.endDate);
						}
						else if (this.myFormFromDate.value.myFromDate == null && this.myFormTodate.value.myToDate != null)
						{
								this.leaseFilter.dateRangeType = 0;
								this.leaseFilter.dateStart = null;
								this.leaseFilter.dateEnd = new Date(this.myFormTodate.value.myToDate.date.year, this.myFormTodate.value.myToDate.date.month - 1, this.myFormTodate.value.myToDate.date.day + 1);;
						}
						else if (this.myFormFromDate.value.myFromDate != null && this.myFormTodate.value.myToDate == null) {
								this.leaseFilter.dateStart = new Date(this.myFormFromDate.value.myFromDate.date.year, this.myFormFromDate.value.myFromDate.date.month - 1, this.myFormFromDate.value.myFromDate.date.day + 1);
								this.leaseFilter.dateEnd = null;
								this.leaseFilter.dateRangeType = 0;
						}
						else if (this.myFormFromDate.value.myFromDate == null && this.myFormTodate.value.myToDate == null) {
								this.leaseFilter.dateStart = null;
								this.leaseFilter.dateEnd = null;
								this.leaseFilter.dateRangeType = 0;
						}

				}
	}

	ReloadResultSetData() {
		this.deletedPropertyIdFromExistingList = "";
		this.tenantLeaseService.deletedLeaseIdFromList = this.deletedPropertyIdFromExistingList;
		if (this.tenantLeaseService.propertyName != "" && this.tenantLeaseService.propertyName != undefined) {
			this.GetPropertyDetails(this.tenantLeaseService.propertyName);
		}
		else if (this.tenantLeaseService.companyName != "" && this.tenantLeaseService.companyName != undefined) {
			this.GetCompanyNameDetails(this.tenantLeaseService.companyName);
		}
		else if (this.tenantLeaseService.propertyName == "" && this.tenantLeaseService.companyName == "") {
			this.onTenantLeaseFilterChange(event,true);
		}
	}
	//Remove building from right side map 05102019
	DeleteFromArray(index, id) {

		this.tenantLeaseBuildingList = this.tenantLeaseBuildingList.filter(function( obj ) {
			return obj.leaseId !== id;
		});

		this.tenantLeaseBuildingListCopy = this.tenantLeaseBuildingListCopy.filter(function( obj ) {
			return obj.leaseId !== id;
		});
		
		var that = this;
		let totalSF = 0;
		let est_SRate = 0;
		let tenant_Imp = 0;
		this.deletedPropertyIdFromExistingList += id + ",";
		//console.log(this.deletedPropertyIdFromExistingList);
		if (this.tenantLeaseBuildingListCopy.length == 0) {
			this.tenantLeaseBuildingListCopy.filter(function (location) {
				totalSF = 0;
				est_SRate = 0;
			});
		}
		that.tenantLeaseBuildingList.filter(function (location) {
			totalSF = Number(totalSF) + Number(location["squareFootage"]);
			est_SRate = Number(est_SRate) + Number(location["estimatedStartingFSRate"]);
			tenant_Imp = Number(tenant_Imp) + Number(location["tenantImprovements"]);
		});
		this.TenantLeaseobj.totalSF = totalSF;
		this.TenantLeaseobj.tenant_Imp = tenant_Imp;
		this.TenantLeaseobj.est_SRate = (Number(est_SRate));

		this.Tenant_Imp = (Number(that.TenantLeaseobj.tenant_Imp) / (this.tenantLeaseBuildingList.length));
		this.est_StartingRate = (Number(that.TenantLeaseobj.est_SRate) / Number(this.tenantLeaseBuildingList.length));
		this.totalbuilding = this.tenantLeaseBuildingList.length;

		//Service list updating for pdf export
		this.tenantLeaseService.tenantLeaseBuildingList = this.tenantLeaseBuildingList.filter(obj => obj.leaseId != -1);
		this.tenantLeaseService.deletedLeaseIdFromList = this.deletedPropertyIdFromExistingList;
	}
	GetPropertyDetails(propertyName) {
		this.mapLoader = true;
		this.IsPropertyNameselected = true;
		this.tenantLeaseService.propertyName = propertyName;
		this.tenantLeaseService.companyName = "";
		this.deletedPropertyIdFromExistingList = "";
		this.tenantLeaseService.tenantLeaseBuildingList = this.deletedPropertyIdFromExistingList;
		this.tenantLeaseService.GetPropertyDetails(this.multipleName, propertyName, this.leaseFilter.dateRangeType, this.deletedPropertyIdFromExistingList).subscribe(
			(res: any) => {

				this.tenantLeaseBuildingList = res.filter(obj => obj.leaseId != -1);
				//Service list updating for pdf export
				this.tenantLeaseService.tenantLeaseBuildingList = res.filter(obj => obj.leaseId != -1)
				this.tenantLeaseBuildingListCopy = this.tenantLeaseService.tenantLeaseBuildingList.slice(0, 50);
				this.rightSectionColor = { 'background': '#ffffff' };
				this.pushInMarker();
				},
				err => {
					this.mapLoader = false;
				}
			);
	}
	GetCompanyNameDetails(companyName) {
		this.mapLoader = true;
		this.IsPropertyNameselected = true;
		this.tenantLeaseService.companyName = companyName;
		this.tenantLeaseService.propertyName = "";
		this.deletedPropertyIdFromExistingList = "";
		this.tenantLeaseService.tenantLeaseBuildingList = this.deletedPropertyIdFromExistingList;
		this.tenantLeaseService.GetCompanyNameDetails(this.multipleName, companyName, this.leaseFilter.dateRangeType, this.deletedPropertyIdFromExistingList).subscribe(
			(res: any) => {
				this.tenantLeaseBuildingList = res.filter(obj => obj.leaseId != -1);
				//Service list updating for pdf export
				this.tenantLeaseService.tenantLeaseBuildingList = res.filter(obj => obj.leaseId != -1)
				this.tenantLeaseBuildingListCopy = this.tenantLeaseService.tenantLeaseBuildingList.slice(0, 50);
				this.rightSectionColor = { 'background': '#ffffff' };

				this.pushInMarker();
				},
				err => {
					this.mapLoader = false;
				}
			);
	}

	GenerateSinglePopupRecordPdf(leaseId) {
		this.mapLoader = true;
		this.tenantLeaseService.GenerateSinglePopupRecordPdf(leaseId).subscribe(
			(res: Blob) => {                  
			  saveAs(res, 'SinglePopUpData.pdf');
			  this.mapLoader = false;
			},
			err => {
			  console.log(err)
			  this.mapLoader = false;
			}
		);
	}

	GetTenantLeaseStatus() {
		//Api calling for SubMarketList
		this.tenantLeaseService.GetTenantLeaseStatus().subscribe(
			(res: string[]) => {
				this.statusOptions = res;
			},
			err => {

			}
		);
	}

	GetTenantCity() {
		//Api calling for CityList
		this.tenantLeaseService.GetTenantCity().subscribe(
			(res: string[]) => {
				this.cityOptions = res;
			},
			err => {

			}
		);
	}

	GetTenantZip() {
		//Api calling for ZipList
		this.tenantLeaseService.GetTenantZip().subscribe(
			(res: string[]) => {
				this.postalOptions = res;
			},
			err => {

			}
		);
	}

	mapTypeIdChanged(maptype) {
		//alert(maptype);
	}
	zoomChanged(zoom) {
		console.log("zoom", zoom);
	}
}

interface Absorption {
	quarter: string,
	quarterYear: string,
	id: string,
	propertyId: string
}
export interface location {
	latitude: number;
	longitude: number;
	label?: string;
	draggable: boolean;
}
interface marker {
	latitude: number;
	longitude: number;
	label?: string;
	draggable: boolean;
	IconUrl: string;
}